import { type ReactNode } from 'react';

export function AuthFrame(props: {
  title: string;
  subtitle: string;
  brand?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="admin-auth-enter w-full max-w-[24rem]">
      <div className="rounded-[var(--admin-radius,0.625rem)] border border-white/10 bg-white p-7 shadow-[var(--admin-shadow-md)] sm:p-8 dark:border-slate-700 dark:bg-slate-900">
        {props.brand ? <div className="mb-6 lg:hidden">{props.brand}</div> : null}
        <h2 className="admin-display text-[1.75rem] font-semibold text-slate-950 sm:text-[1.9rem] dark:text-white">
          {props.title}
        </h2>
        <p className="mt-2 max-w-prose text-sm leading-relaxed text-slate-500 dark:text-slate-400">
          {props.subtitle}
        </p>
        <div className="mt-7">{props.children}</div>
      </div>
    </div>
  );
}
